import Vue from 'vue';
import calendarLectures from "../components/calendar/calendar-lectures.vue";
import { bannerDate } from "../config/banner"
import banner from "../components/banner/banner"

if(document.getElementById("main-page")){
    new Vue({
        el: '#main-page',
        data: {
            load: true,
            bannerDate: bannerDate,
            bannerHtml,
            bannerCss
        },
        components: {
            calendarLectures,
            banner
        },

    });
}
